import taskTemplateLookupItemUrl from './taskTemplateLookupItem.html';

class TaskTemplateLookupItemCtrl {
  constructor(pluralizeFilter) {
    'ngInject';

    Object.assign(this, { pluralizeFilter });
  }

  getDescription() {
    const subtasksCount = this.template.subtasks.length || 0;
    return `${subtasksCount} ${this.pluralizeFilter(this.template.subtasks, 'subtask')}`;
  }
}

export default {
  templateUrl: taskTemplateLookupItemUrl,
  controller: TaskTemplateLookupItemCtrl,
  controllerAs: 'ctrl',
  bindings: {
    template: '<',
  },
};
